export default __webpack_public_path__ + "static/media/ManagerTemplate.94d248bc.csv";